var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 404,
    height: 239.534,
    viewBox: "0 0 404 239.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 0.489,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00405f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.149,
    x2: 0.512,
    y2: 0.928,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009dd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00405f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Intersection_1",
    x: 65.55,
    y: 60.477,
    width: 277.019,
    height: 143.01,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.71
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    d: "M50,0H192.562a50,50,0,0,1,50,50V79.187a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V50A50,50,0,0,1,50,0Z",
    fill: "#337ab7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(2281 -5158.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(-2229.224 5206.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M.007,155.33c0-.507-.007-1.016-.007-1.524C0,68.862,68.179,0,152.285,0S304.567,68.862,304.567,153.806c0,.508,0,1.017-.007,1.524Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -51.78, -47.66)",
    filter: "url(#Intersection_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1-2",
    "data-name": "Intersection 1",
    d: "M0,134.01A134.008,134.008,0,0,1,134.01,0c45.368,0,85.47,22.546,110.2,57.736a132.742,132.742,0,0,1,23.812,76.274Z",
    transform: "translate(70.05 68.98)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(-2281 5158.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M11.586,4.49a3.046,3.046,0,0,1,5.814,0L28.486,39.964a3.046,3.046,0,0,1-2.907,3.954L13.623,39.964,3.407,43.918A3.046,3.046,0,0,1,.5,39.964Z",
    transform: "translate(185.984 -2.353)",
    fill: "#00659c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M11.226,2.137a3.046,3.046,0,0,1,5.814,0L28.126,37.611a3.046,3.046,0,0,1-2.907,3.954L13.263,37.611,3.048,41.565A3.046,3.046,0,0,1,.141,37.611Z",
    transform: "translate(404 169.484) rotate(90)",
    fill: "#00659c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M11.226,2.137a3.046,3.046,0,0,1,5.814,0L28.126,37.611a3.046,3.046,0,0,1-2.907,3.954L13.263,37.611,3.048,41.565A3.046,3.046,0,0,1,.141,37.611Z",
    transform: "translate(0 197.751) rotate(-90)",
    fill: "#00659c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M16.269,16.431l.845,3.4a32.577,32.577,0,0,1-4.419.342,14.517,14.517,0,0,1-4.939-.662,4.929,4.929,0,0,1-2.47-1.741q-.715-1.079-.715-4.54V.17H.281V-2.821H4.571V-8.44l5.817-2.308v7.927h5.882V.17H10.387V13.439a4.548,4.548,0,0,0,.309,2.115A2.071,2.071,0,0,0,11.7,16.3a5.625,5.625,0,0,0,2,.278Q14.676,16.58,16.269,16.431Zm5.654,3.44V-2.821h5.264V.619a11.359,11.359,0,0,1,3.721-3.184,9.025,9.025,0,0,1,3.753-.769,15.912,15.912,0,0,1,6.011,1.239L38.657,1.474A11.768,11.768,0,0,0,34.368.641a7.638,7.638,0,0,0-3.444.759,4.565,4.565,0,0,0-2.177,2.1,10.319,10.319,0,0,0-.975,4.487v11.88Zm44.842,0V16.538q-4.029,3.846-10.951,3.846a20.364,20.364,0,0,1-5.7-.769,10.009,10.009,0,0,1-3.932-1.934,6.27,6.27,0,0,1-1.8-2.852,13,13,0,0,1-.357-3.59V-2.821h5.849V9.764a14.91,14.91,0,0,0,.357,4.06,4.321,4.321,0,0,0,2.34,2.382,10.1,10.1,0,0,0,4.419.865,13.648,13.648,0,0,0,4.939-.887,6.382,6.382,0,0,0,3.266-2.414,8.4,8.4,0,0,0,.959-4.434V-2.821H72V19.871Zm38.019-7.307,6.044.491a10.451,10.451,0,0,1-5.3,5.406,22.169,22.169,0,0,1-9.878,1.923q-7.571,0-12.007-3.066a9.862,9.862,0,0,1-4.435-8.6A10.25,10.25,0,0,1,83.695-.171q4.484-3.162,11.633-3.162,6.921,0,11.308,3.1a10.056,10.056,0,0,1,4.387,8.718q0,.342-.033,1.026H85.254a7.351,7.351,0,0,0,3.217,5.726,14.1,14.1,0,0,0,12.705.876A8.166,8.166,0,0,0,104.784,12.563Zm-19.2-6.218h19.269a6.273,6.273,0,0,0-2.21-4.295A11.29,11.29,0,0,0,95.393-.171,12.236,12.236,0,0,0,88.617,1.6,6.187,6.187,0,0,0,85.579,6.346Zm34.249,13.525v-4.38h6.661v4.38Zm17.385,0V-11.453h9.358l19.5,20.918V-11.453H175V19.871h-9.651L146.149-.556V19.871ZM183,8.2a9.172,9.172,0,0,1,2.242-5.79,13.913,13.913,0,0,1,6.353-4.273,27.046,27.046,0,0,1,9.18-1.474q7.831,0,12.835,3.344t5,8.451q0,5.149-5.053,8.536t-12.722,3.387a28.888,28.888,0,0,1-9.05-1.41,13.767,13.767,0,0,1-6.548-4.135A10.1,10.1,0,0,1,183,8.2Zm9.358.321a6.03,6.03,0,0,0,2.437,5.171,9.859,9.859,0,0,0,6.011,1.795,9.787,9.787,0,0,0,6-1.795,6.089,6.089,0,0,0,2.421-5.214A6,6,0,0,0,206.8,3.354a10.937,10.937,0,0,0-12.007,0A6.03,6.03,0,0,0,192.356,8.525ZM234.5,19.871h-9.131V-2.821h8.481V.406a12.506,12.506,0,0,1,3.916-3.013,10.158,10.158,0,0,1,3.948-.726A16.344,16.344,0,0,1,247.727-2.2L244.9,3.034a11,11,0,0,0-4.289-.983,6.962,6.962,0,0,0-3.249.694,4.748,4.748,0,0,0-2.1,2.511q-.764,1.816-.764,7.607ZM267.483-2.821V1.965h-6.239V11.11a15.043,15.043,0,0,0,.179,3.237,1.484,1.484,0,0,0,.812.759,3.6,3.6,0,0,0,1.543.3,17.144,17.144,0,0,0,3.672-.577l.78,4.658a26.618,26.618,0,0,1-7.214.9,16.8,16.8,0,0,1-4.452-.545,6.959,6.959,0,0,1-2.908-1.41,4.588,4.588,0,0,1-1.284-2.34,19.273,19.273,0,0,1-.292-4.231V1.965h-4.192V-2.821h4.192V-7.329l9.163-3.5v8.013Zm15.435-8.632V.064a16.818,16.818,0,0,1,10.561-3.4,19.551,19.551,0,0,1,5.687.769A9.691,9.691,0,0,1,302.984-.6a6.261,6.261,0,0,1,1.755,2.65,15.789,15.789,0,0,1,.471,4.508V19.871h-9.131V7.884q0-3.568-.52-4.53a3.591,3.591,0,0,0-1.836-1.528,8.374,8.374,0,0,0-3.3-.566,10.71,10.71,0,0,0-4.062.726,5.07,5.07,0,0,0-2.616,2.19,8.978,8.978,0,0,0-.829,4.327V19.871h-9.131V-11.453Z",
    transform: "translate(47.912 219.15)",
    fill: "#01415e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(81.696 123.798)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 70.05,
    height: 24.365,
    transform: "translate(0 79.48) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 106.598,
    height: 24.365,
    transform: "translate(48.731 82.526) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 67.005,
    height: 24.365,
    transform: "translate(101.093 78.894) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 63.959,
    height: 24.365,
    transform: "translate(151.977 79.787) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 45.685,
    height: 24.365,
    transform: "translate(189.264 91.23) rotate(-45)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.53ffde380cf0944fb1711b9dcf38176c.svg";
export { ForwardRef as ReactComponent };